import {
  KineticFormFragmentFragment,
  KineticFormViewFragmentFragment,
} from '@kinetic-ui/data-layer';

export type KineticForm = KineticFormFragmentFragment;

export type KineticFormView = KineticFormViewFragmentFragment;

export const FormMode = {
  CLONE: 'clone',
  CREATE: 'create',
  EDIT: 'edit',
} as const;

export type FormModeType = (typeof FormMode)[keyof typeof FormMode];
